import { render, staticRenderFns } from "./sms-info-card-body.vue?vue&type=template&id=8bda80ae&scoped=true"
import script from "./sms-info-card-body.vue?vue&type=script&lang=js"
export * from "./sms-info-card-body.vue?vue&type=script&lang=js"
import style0 from "./sms-info-card-body.vue?vue&type=style&index=0&id=8bda80ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bda80ae",
  null
  
)

export default component.exports